import React from "react";
import PropTypes from "prop-types";

export default function WarrantyCard({
    productName,
    url
}) {
    return (
        <a className="warrantyCard" href={url}>
            <h2>{productName}</h2>
        </a>
    )
}

WarrantyCard.propTypes = {
    productName: PropTypes.string.isRequired,
    url: PropTypes.string.isRequired
}